import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-overview-tab-2-part',
	standalone: true,
	templateUrl: './delivery-overview-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-overview-tab-2.part.scss`],
})
export class DeliveryOverviewTab2Part {
}
